import { listToTree } from '@/utils/utils';

const mutations = {
  // state指的是state的数据, name传递过来的数据
  setSideMenu(state, name) {
    state.sideMenu = name; // 将传参设置给state的city
  },
  setCollapsed(state, collapsed) {
    state.collapsed = collapsed;
  },
  setMenus(state, data) {
    const temp = listToTree(data[0] || [], 0);
    state.menus = temp;
  },
  setRouters(state, data) {
    const temp = data;
    state.routers = temp;
  },
  setPermissions(state, data) {
    state.permissions = data;
  },
  setUsers(state, data) {
    state.users = data;
  },
  setAllUsers(state, data) {
    state.allUsers = data;
  },
  setProjectId(state, data) {
    state.projectId = data;
  },
  setUserInfo(state) {
    state.userInfo = JSON.parse(window.localStorage.getItem('user_info') || '{}');
  },
  setGlobalConfig(state, data) {
    state.globalConfigList = data || {};
  },
  selectedNode(state, val) {
    state.selectedNode = val;
  },
  setDesign(state, val) {
    state.design = val;
  }
};

export default mutations;
